import { ButtonColors, ButtonTypes } from '../../gzButton/types';
export interface BulkActionsBarButton {
  text: string;
  value?: string;
  action?: Function;
  color?: ButtonColors;
  type?: ButtonTypes;
  disabled?: boolean;
}

export enum BulkActionsBarEvents {
  CLICK = 'bulkActionsBarClick',
}
